import React, { useState } from "react";
import { navigate } from "@reach/router";
import { Form, Button } from "react-bootstrap"
import queryString from 'query-string';
import $ from 'jquery';

import {CustomLinks} from "../../common/utils";

const NewsSearch = (props) => {

    let query_params = queryString.parse(props.location.search);
    var srch_text = query_params.q ? query_params.q : '';

    const[search_text, setSearchText] = useState(srch_text ? srch_text : '');

    const handleChange = (e) =>{
        setSearchText(e.target.value);
    }

    const handleSubmit = () =>{

        let baseUrl = CustomLinks.insights; // default to insights
        if (props.location.pathname.includes('/case-studies')) {
            baseUrl = CustomLinks.case_studies;
        } else if (props.location.pathname.includes('/landlord-resource-center')) {
            baseUrl = CustomLinks.landlord_resource_center;
        }

        search_text ? navigate(`${baseUrl}/?q=${search_text}`) : navigate(baseUrl);
        // search_text ? navigate(`${CustomLinks.insights}/?q=${search_text}`) 
        // : navigate(`${CustomLinks.insights}`);

        $('html, body').animate({
            scrollTop: $(".features-section").offset().top-140
        }, 1000);
    }

    const resetSrch = () => {
        setSearchText('');
        // navigate(`${CustomLinks.insights}`);
        let baseUrl = CustomLinks.insights;
        if (props.location.pathname.includes('/case-studies')) {
            baseUrl = CustomLinks.case_studies;
        } else if (props.location.pathname.includes('/landlord-resource-center')) {
            baseUrl = CustomLinks.landlord_resource_center;
        }
        navigate(baseUrl);
        $('html, body').animate({
            scrollTop: $(".features-section").offset().top-140
        }, 1000);
    }

    return (
        <React.Fragment>
            <Form action={`javascript:;`} onSubmit={handleSubmit}>
                <Form.Control type="text" name="q" placeholder="Search by title or content" value={search_text} onChange={handleChange} autoComplete={false} />
                <span className="clear_btn" onClick={() => resetSrch()}>X</span>
                <Button type="submit" className="btn-submit" variant="link"><i className="icon-search-white"></i></Button>
            </Form>
        </React.Fragment >
    );
};
export default NewsSearch;
